import { render, staticRenderFns } from "./labelManege.vue?vue&type=template&id=33e81750&scoped=true"
import script from "./labelManege.vue?vue&type=script&lang=js"
export * from "./labelManege.vue?vue&type=script&lang=js"
import style0 from "./labelManege.vue?vue&type=style&index=0&id=33e81750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e81750",
  null
  
)

export default component.exports